// Copyright (c) 2022 by Move Closer

import { ThemeRegistry, VariantRegistry } from '../../composables'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export enum Theme {
  Primary = 'primary',
  Secondary = 'secondary',
  Dark = 'dark'
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const themeRegistry: ThemeRegistry<string> = {
  [Theme.Primary]: '--primary', // TODO: this should be empty and link should have default styles (like for --primary)
  [Theme.Secondary]: '--secondary',
  [Theme.Dark]: '--dark'
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export enum Variant {
  Full = 'full',
  Outline = 'outline',
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const variantRegistry: VariantRegistry<string> = {
  [Variant.Full]: '',
  [Variant.Outline]: '--outline'
}
